import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../layout";
import FormTextField from "../../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../../components/toast/successToast";
import errorToast from "../../../components/toast/errorToast";
import { FormDropDown } from "../../../components/form/dropdown";
import { useState } from "react";
import { useEffect } from "react";
import { api } from "../../../redux/apis/api";
import { FormToggleSwitch } from "../../../components/form/checkbox";

const EditRoles = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/ffadmin/role/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const initialValues = {
    id: params?.id,
    name: data?.name ?? "",
    type: data?.type ?? "",
    enabled: data?.enabled ?? false,
    permissions: {
      Module: {
        read: "read",
        write: "write",
        all_data: "all_data",
        only_associated: "only_associated",
      },
      employee: {
        read: data?.employee?.read === true ? true : false,
        write: data?.employee?.write === true ? true : false,
        all_data: data?.employee?.all_data === true ? true : false,
        only_associated:
          data?.employee?.only_associated === true ? true : false,
      },
      company: data?.company ?? {
        read: data?.company?.read === true ? true : false,
        write: data?.company?.write === true ? true : false,
        all_data: data?.company?.all_data === true ? true : false,
        only_associated: data?.company?.only_associated === true ? true : false,
      },
      lead: data?.lead ?? {
        read: data?.lead?.read === true ? true : false,
        write: data?.lead?.write === true ? true : false,
        all_data: data?.lead?.all_data === true ? true : false,
        only_associated: data?.lead?.only_associated === true ? true : false,
      },
      customer: {
        read: data?.customer?.read === true ? true : false,
        write: data?.customer?.write === true ? true : false,
        all_data: data?.customer?.all_data === true ? true : false,
        only_associated:
          data?.customer?.only_associated === true ? true : false,
      },
      product: {
        read: data?.product?.read === true ? true : false,
        write: data?.product?.write === true ? true : false,
        all_data: data?.product?.all_data === true ? true : false,
        only_associated: data?.product?.only_associated === true ? true : false,
      },
      order: {
        read: data?.order?.read === true ? true : false,
        write: data?.order?.write === true ? true : false,
        all_data: data?.order?.all_data === true ? true : false,
        only_associated: data?.order?.only_associated === true ? true : false,
      },
      marketing_material: {
        read: data?.marketing_material?.read === true ? true : false,
        write: data?.marketing_material?.write === true ? true : false,
        all_data: data?.marketing_material?.all_data === true ? true : false,
        only_associated:
          data?.marketing_material?.only_associated === true ? true : false,
      },
      employee_live_tracking: {
        read: data?.employee_live_tracking?.read === true ? true : false,
        write: data?.employee_live_tracking?.write === true ? true : false,
        all_data:
          data?.employee_live_tracking?.all_data === true ? true : false,
        only_associated:
          data?.employee_live_tracking?.only_associated === true ? true : false,
      },
      lead_activity: {
        read: data?.lead_activity?.read === true ? true : false,
        write: data?.lead_activity?.write === true ? true : false,
        all_data: data?.lead_activity?.all_data === true ? true : false,
        only_associated:
          data?.lead_activity?.only_associated === true ? true : false,
      },
      customer_activity: {
        read: data?.customer_activity?.read === true ? true : false,
        write: data?.customer_activity?.write === true ? true : false,
        all_data: data?.customer_activity?.all_data === true ? true : false,
        only_associated:
          data?.customer_activity?.only_associated === true ? true : false,
      },
      employee_request: {
        read: data?.employee_request?.read === true ? true : false,
        write: data?.employee_request?.write === true ? true : false,
        all_data: data?.employee_request?.all_data === true ? true : false,
        only_associated:
          data?.employee_request?.only_associated === true ? true : false,
      },
      payment: {
        read: data?.payment?.read === true ? true : false,
        write: data?.payment?.write === true ? true : false,
        all_data: data?.payment?.all_data === true ? true : false,
        only_associated: data?.payment?.only_associated === true ? true : false,
      },
      settings: {
        read: data?.settings?.read === true ? true : false,
        write: data?.settings?.write === true ? true : false,
        all_data: data?.settings?.all_data === true ? true : false,
        only_associated:
          data?.settings?.only_associated === true ? true : false,
      },
      tile_layer: {
        read: data?.tile_layer?.read === true ? true : false,
        write: data?.tile_layer?.write === true ? true : false,
        all_data: data?.tile_layer?.all_data === true ? true : false,
        only_associated:
          data?.tile_layer?.only_associated === true ? true : false,
      },
      expense: {
        read: data?.expense?.read === true ? true : false,
        write: data?.expense?.write === true ? true : false,
        all_data: data?.expense?.all_data === true ? true : false,
        only_associated: data?.expense?.only_associated === true ? true : false,
      },
    },
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    const submitValue = { ...values };

    if (submitValue.permissions?.Module) {
      delete submitValue.permissions.Module;
    }

    const finalData = {
      id: params?.id,
      name: submitValue?.name ?? "",
      type: submitValue?.type ?? "",
      enabled: submitValue?.enabled ?? false,
      ...submitValue.permissions,
    };

    api
      .post(`/ffadmin/role/edit`, finalData)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        navigate(`/admin/roles/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const TypeOptions = [
    { label: "Admin", value: "admin" },
    { label: "Employee", value: "employee" },
  ];

  const modelLabels = {
    employee: "Employee",
    company: "Company",
    lead: "Lead",
    customer: "Customer",
    product: "Product",
    order: "Order",
    marketing_material: "Marketing Material",
    employee_live_tracking: "Employee Live Tracking",
  };

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Admin Roles - Edit
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => navigate("/admin/roles/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"name"}
                    label={"role name"}
                    placeholder={`Enter role name`}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name={"type"}
                    label={"type"}
                    options={TypeOptions}
                    value={TypeOptions?.find(
                      (item) => item?.value === values?.type
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormToggleSwitch
                    name={"enabled"}
                    label={"enabled"}
                    value={values?.enabled}
                  />
                </div>
                <div>
                  {Object.keys(values.permissions).map((modelKey) => (
                    <div key={modelKey} className="flex justify-between">
                      <div className="p-2 w-full max-w-[16rem]">
                        {(modelLabels[modelKey] || modelKey) === "Module" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            Module Name
                          </p>
                        ) : (
                          modelLabels[modelKey] || modelKey
                        )}
                      </div>

                      <div className="p-2 w-full max-w-[5rem]">
                        {values?.permissions[modelKey].read === "read" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            Read
                          </p>
                        ) : (
                          <Field
                            disabled={values?.permissions[modelKey].write}
                            type="checkbox"
                            name={`permissions.${modelKey}.read`}
                          />
                        )}
                      </div>

                      <div className="p-2  w-full max-w-[5rem]">
                        {values?.permissions[modelKey].write === "write" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            write
                          </p>
                        ) : (
                          <input
                            type="checkbox"
                            checked={values.permissions[modelKey].write}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFieldValue(
                                `permissions.${modelKey}.write`,
                                checked
                              );
                              if (checked) {
                                setFieldValue(
                                  `permissions.${modelKey}.read`,
                                  true
                                );
                              }
                            }}
                          />
                        )}
                      </div>

                      <div className="p-2 w-full max-w-[5rem]">
                        {values?.permissions[modelKey].all_data ===
                        "all_data" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            All data
                          </p>
                        ) : (
                          <input
                            type="checkbox"
                            checked={values.permissions[modelKey].all_data}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFieldValue(
                                `permissions.${modelKey}.all_data`,
                                checked
                              );
                              if (checked) {
                                setFieldValue(
                                  `permissions.${modelKey}.only_associated`,
                                  false
                                );
                              }
                            }}
                          />
                        )}
                      </div>

                      <div className="p-2 w-full max-w-[8rem]">
                        {values?.permissions[modelKey].only_associated ===
                        "only_associated" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            only associated
                          </p>
                        ) : (
                          <input
                            type="checkbox"
                            checked={
                              values.permissions[modelKey].only_associated
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFieldValue(
                                `permissions.${modelKey}.only_associated`,
                                checked
                              );
                              if (checked) {
                                // Uncheck all_data if only_associated is selected
                                setFieldValue(
                                  `permissions.${modelKey}.all_data`,
                                  false
                                );
                              }
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditRoles;
